import React from 'react';
import { TabGroup, TabList, Tab, TabPanels, TabPanel } from '@headlessui/react';
import FormInput from './FormInput';

function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}

export default function MemberFormTabs({ memberForm, fund, memberFormErrors, errors, exampleSpreadsheetPath, invoicingMembersPath, importInvoicingMembersPath, uploadMembersPath }) {
  return (
    <div className="mt-10">
      <TabGroup>
        <div className="border-b border-gray-200">
          <TabList className="-mb-px flex space-x-8 justify-center">
            <Tab className="
          data-[selected]:border-indigo-500
          data-[selected]:text-indigo-600
          data-[hover]:border-gray-300
          data-[hover]:text-gray-700
          border-transparent text-gray-500
          whitespace-nowrap border-b-2 px-1 py-4 text-sm font-medium
          ">
              Add Single Member
            </Tab>
            <Tab className="
          data-[selected]:border-indigo-500
          data-[selected]:text-indigo-600
          data-[hover]:border-gray-300
          data-[hover]:text-gray-700
          border-transparent text-gray-500
          whitespace-nowrap border-b-2 px-1 py-4 text-sm font-medium
          ">
              Upload Spreadsheet
            </Tab>
          </TabList>
        </div>
        <TabPanels>
          <TabPanel className="px-4 py-5 sm:p-6 bg-white rounded-lg">
            <NewMemberForm memberForm={memberForm} invoicingMembersPath={invoicingMembersPath} fund={fund} memberFormErrors={memberFormErrors} errors={errors} />
          </TabPanel>
          <TabPanel className="px-4 py-5 sm:p-6 bg-white rounded-lg">
            <UploadFormLink uploadMembersPath={uploadMembersPath} exampleSpreadsheetPath={exampleSpreadsheetPath} />
          </TabPanel>
        </TabPanels>
      </TabGroup>
    </div>
  );
}


const NewMemberForm = ({ memberForm, invoicingMembersPath, fund, memberFormErrors }) => {

  return (
    <div className="font-body max-w-3xl mx-auto mt-8 mb-20">
      <form action={invoicingMembersPath} method="post" encType="multipart/form-data">
        <input type="hidden" name="authenticity_token" value={document.getElementsByName("csrf-token")[0].content} />
        <div className="mt-8">
          <div className="mt-6 grid grid-cols-1 gap-x-6 gap-y-4 sm:grid-cols-6">
            <div className="col-span-1 sm:col-span-3">
              <FormInput
                modelName="user"
                model={memberForm}
                attribute="first_name"
                label="First Name"
                type="text"
                required={true}
                errors={memberFormErrors.messages && memberFormErrors.messages["first_name"]}
              />
            </div>
            <div className="col-span-1 sm:col-span-3">
              <FormInput
                modelName="user"
                model={memberForm}
                attribute="last_name"
                label="Last Name"
                type="text"
                required={true}
                errors={memberFormErrors.messages && memberFormErrors.messages["last_name"]}
              />
            </div>
            <div className="col-span-1 sm:col-span-3">
              <FormInput
                modelName="user"
                model={memberForm}
                attribute="email"
                label="Email"
                type="text"
                required={true}
                errors={memberFormErrors.messages && memberFormErrors.messages["email"]}
              />
            </div>
            <div className="col-span-1 sm:col-span-3">
              <FormInput
                modelName="user"
                model={memberForm}
                attribute="membership_id"
                label="Membership ID"
                type="text"
                required={true}
                errors={memberFormErrors.messages && memberFormErrors.messages["membership_id"]}
              />
            </div>
            {fund.dues_calculation_type == 'indivitual' && (
              <div className="col-span-1 sm:col-span-3">
                <FormInput
                  className="col-span-1 sm:col-span-3"
                  modelName="user"
                  model={memberForm}
                  attribute="dues_amount"
                  label="Monthly Dues Amount"
                  type="number"
                  required={true}
                  errors={memberFormErrors.messages && memberFormErrors.messages["dues_amount"]}
                />
              </div>
            )}
            <div className="hidden sm:block sm:col-span-6"></div>
          </div>
        </div>
        <div className="font-body pt-5">
          <div className="flex justify-end">
            <span className="inline-flex rounded-md shadow-sm">
              <a href={invoicingMembersPath}
                className="py-2 px-4 bg-white border border-gray-300 rounded-md text-sm leading-5 font-medium text-gray-700 hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue active:bg-gray-50 active:text-gray-800 transition duration-150 ease-in-out">
                Cancel
              </a>
            </span>
            <span className="ml-3 inline-flex rounded-md shadow-sm">
              <button type="submit"
                className="inline-flex justify-center py-2 px-20 border border-transparent text-sm leading-5 font-medium rounded-md text-white bg-indigo-700 hover:bg-indigo-600 focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo active:bg-indigo-700 transition duration-150 ease-in-out">
                Add Member
              </button>
            </span>
          </div>
        </div>
      </form>
    </div>

  );
}

const UploadFormLink = ({ uploadMembersPath, exampleSpreadsheetPath }) => {
  return (
    <div className="font-body max-w-3xl mx-auto mb-20">
      <div className="text-center py-12">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="mx-auto h-16 w-16 text-gray-400">
          <path strokeLinecap="round" strokeLinejoin="round" d="M18 18.72a9.094 9.094 0 003.741-.479 3 3 0 00-4.682-2.72m.94 3.198l.001.031c0 .225-.012.447-.037.666A11.944 11.944 0 0112 21c-2.17 0-4.207-.576-5.963-1.584A6.062 6.062 0 016 18.719m12 0a5.971 5.971 0 00-.941-3.197m0 0A5.995 5.995 0 0012 12.75a5.995 5.995 0 00-5.058 2.772m0 0a3 3 0 00-4.681 2.72 8.986 8.986 0 003.74.477m.94-3.197a5.971 5.971 0 00-.94 3.197M15 6.75a3 3 0 11-6 0 3 3 0 016 0zm6 3a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0zm-13.5 0a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0z" />
        </svg>
        <h2 className="mt-4 text-2xl font-medium text-gray-900">Upload Members via Spreadsheet</h2>
        <p className="mt-2 text-sm text-gray-500 max-w-md mx-auto">
          Import multiple members at once from a spreadsheet. Configure invoice creation, email notifications, and more.
        </p>
        <div className="mt-6 flex flex-col items-center gap-3">
          <a
            href={uploadMembersPath}
            className="inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
          >
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-5 h-5 mr-2">
              <path strokeLinecap="round" strokeLinejoin="round" d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5m-13.5-9L12 3m0 0l4.5 4.5M12 3v13.5" />
            </svg>
            Go to Upload Page
          </a>
          <a href={`${exampleSpreadsheetPath}.xlsx`} className="text-sm text-indigo-600 hover:text-indigo-500">
            Download template spreadsheet →
          </a>
        </div>
        <div className="mt-8 bg-gray-50 rounded-lg p-4 max-w-md mx-auto">
          <p className="text-xs font-medium text-gray-700 mb-2">Required spreadsheet columns:</p>
          <div className="flex flex-wrap gap-1 justify-center">
            {['Membership ID', 'First Name', 'Last Name', 'Email', 'Dues Amount'].map((col) => (
              <span key={col} className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-indigo-100 text-indigo-800">
                {col}
              </span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}